(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lca-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.lca-hero');
    sections.forEach(initLcaHero);

    function initLcaHero(root) {
      const cells = Array.from(root.querySelectorAll('.lca-hero__cell'));
      const states = Array.from(root.querySelectorAll('.lca-hero__state'));
      const defaultState = root.querySelector('.lca-hero__state--default');

      if (!cells.length) return;

      function showDefault() {
        cells.forEach(c => c.classList.remove('is-active'));
        states.forEach(s => s.classList.remove('is-active'));
        if (defaultState) defaultState.classList.add('is-active');
      }

      function showCell(i) {
        cells.forEach(c => c.classList.remove('is-active'));
        states.forEach(s => s.classList.remove('is-active'));
        const cell = cells[i];
        if (cell) cell.classList.add('is-active');
        const state = root.querySelector('.lca-hero__state[data-state="' + i + '"]');
        if (state) state.classList.add('is-active');
      }

      cells.forEach((cell, i) => {
        cell.addEventListener('mouseenter', () => showCell(i));
        cell.addEventListener('mouseleave', showDefault);
        // touch devices: tap shows the cell, tapping outside returns to default
        cell.addEventListener('focusin', () => showCell(i));
        cell.addEventListener('focusout', showDefault);
      });

      // start in default state
      showDefault();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlrb-compare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReveal(root) {
      var items = root.querySelectorAll('[data-reveal]');
      if (!items.length) return;

      root.classList.add('js-reveal-ready');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-revealed'); });
        return;
      }

      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

      items.forEach(function (el) { io.observe(el); });

      setTimeout(function () {
        items.forEach(function (el) {
          if (!el.classList.contains('is-revealed')) el.classList.add('is-revealed');
        });
      }, 1500);
    }

    function initAll() {
      document.querySelectorAll('.tlrb-compare').forEach(function (root) {
        if (root.dataset.cmpInit === '1') return;
        root.dataset.cmpInit = '1';
        initReveal(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector ? e.target.querySelector('.tlrb-compare') : null;
      if (root) root.dataset.cmpInit = '';
      initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlrb-kennismaking"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReveal(root) {
      var items = root.querySelectorAll('[data-reveal]');
      if (!items.length) return;

      root.classList.add('js-reveal-ready');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-revealed'); });
        return;
      }

      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });

      items.forEach(function (el) { io.observe(el); });

      // Safety net so nothing stays invisible if the observer never fires.
      setTimeout(function () {
        items.forEach(function (el) {
          if (!el.classList.contains('is-revealed')) el.classList.add('is-revealed');
        });
      }, 1500);
    }

    function initAll() {
      document.querySelectorAll('.tlrb-kennismaking').forEach(function (root) {
        if (root.dataset.kmInit === '1') return;
        root.dataset.kmInit = '1';
        initReveal(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector ? e.target.querySelector('.tlrb-kennismaking') : null;
      if (root) root.dataset.kmInit = '';
      initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlrb-referral-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRef2(root) {
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* ---------- Scroll reveal ---------- */
      const items = root.querySelectorAll('[data-reveal]');
      if (items.length) {
        root.classList.add('js-reveal-ready');
        const revealAll = () => items.forEach(el => el.classList.add('is-revealed'));

        if (reduce || !('IntersectionObserver' in window)) {
          revealAll();
        } else {
          const io = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                obs.unobserve(entry.target);
              }
            });
          }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
          items.forEach(el => io.observe(el));
          setTimeout(() => items.forEach(el => el.classList.add('is-revealed')), 1200);
        }
      }

      /* ---------- Voor/na-slider ---------- */
      root.querySelectorAll('[data-compare]').forEach(cmp => {
        const range = cmp.querySelector('.tlrb-ref2__compare-range');
        if (!range) return;

        const setPos = (v) => cmp.style.setProperty('--pos', v + '%');
        range.addEventListener('input', () => setPos(range.value));

        // Korte "nudge" bij eerste keer in beeld: handle wiebelt even,
        // zodat duidelijk is dat je kunt schuiven.
        if (!reduce && 'IntersectionObserver' in window) {
          let nudged = false;
          const io = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
              if (!entry.isIntersecting || nudged) return;
              nudged = true;
              obs.disconnect();
              const seq = [50, 42, 58, 50];
              let i = 0;
              const next = () => {
                if (i >= seq.length) return;
                const from = parseFloat(range.value);
                const to = seq[i++];
                const dur = 420;
                const t0 = performance.now();
                const tick = (now) => {
                  const p = Math.min((now - t0) / dur, 1);
                  const eased = 0.5 - Math.cos(p * Math.PI) / 2;
                  const v = from + (to - from) * eased;
                  range.value = v;
                  setPos(v);
                  if (p < 1) requestAnimationFrame(tick);
                  else setTimeout(next, 60);
                };
                requestAnimationFrame(tick);
              };
              setTimeout(next, 700);
            });
          }, { threshold: 0.5 });
          io.observe(cmp);
        }
      });

      /* ---------- Kit-builder ---------- */
      const kitCards = root.querySelectorAll('[data-kit-item]');
      const kitBar = root.querySelector('[data-kit-bar]');
      const kitSummary = root.querySelector('[data-kit-summary]');
      const kitField = root.querySelector('[data-kit-field]');
      const kitNote = root.querySelector('[data-form-kit-note]');
      const kitNoteSummary = root.querySelector('[data-form-kit-summary]');

      function selectedKit() {
        return Array.from(kitCards)
          .filter(c => c.getAttribute('aria-pressed') === 'true')
          .map(c => c.dataset.kitItem);
      }

      function syncKit() {
        const sel = selectedKit();
        const text = sel.join(', ');
        if (kitSummary) kitSummary.textContent = text;
        if (kitBar) kitBar.hidden = sel.length === 0;
        if (kitField) kitField.value = text;
        if (kitNote) kitNote.hidden = sel.length === 0;
        if (kitNoteSummary) kitNoteSummary.textContent = text;
      }

      kitCards.forEach(card => {
        card.addEventListener('click', () => {
          const pressed = card.getAttribute('aria-pressed') === 'true';
          card.setAttribute('aria-pressed', pressed ? 'false' : 'true');
          syncKit();
        });
      });

      /* ---------- Soepel scrollen naar ankers ---------- */
      root.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', (e) => {
          const id = link.getAttribute('href').slice(1);
          const target = id && document.getElementById(id);
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      });

      /* ---------- Count-up beloningsbedrag ---------- */
      root.querySelectorAll('[data-countup]').forEach(el => {
        const original = el.textContent;
        const match = original.match(/\d[\d.,]*/);
        if (!match || reduce || !('IntersectionObserver' in window)) return;

        const numStr = match[0].replace(/[.,](?=\d{3}\b)/g, '');
        const target = parseInt(numStr, 10);
        if (!isFinite(target) || target <= 0 || target > 1000000) return;

        const prefix = original.slice(0, match.index);
        const suffix = original.slice(match.index + match[0].length);
        let started = false;

        const run = () => {
          if (started) return;
          started = true;
          const dur = 1100;
          const t0 = performance.now();
          const tick = (now) => {
            const p = Math.min((now - t0) / dur, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            el.textContent = prefix + Math.round(eased * target) + suffix;
            if (p < 1) requestAnimationFrame(tick);
            else el.textContent = original;
          };
          requestAnimationFrame(tick);
        };

        const io = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) { run(); obs.disconnect(); }
          });
        }, { threshold: 0.4 });
        io.observe(el);
        setTimeout(run, 1500);
      });

      /* ---------- FAQ: vloeiend open/dicht ---------- */
      if (!reduce && 'animate' in Element.prototype) {
        root.querySelectorAll('.tlrb-ref2__faq-item').forEach(item => {
          const summary = item.querySelector('summary');
          const content = item.querySelector('.tlrb-ref2__faq-a');
          if (!summary || !content) return;
          let animating = false;

          summary.addEventListener('click', (e) => {
            e.preventDefault();
            if (animating) return;
            animating = true;

            if (item.open) {
              const h = content.offsetHeight;
              const anim = content.animate(
                [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
                { duration: 240, easing: 'ease' }
              );
              anim.onfinish = () => { item.open = false; animating = false; };
            } else {
              item.open = true;
              const h = content.offsetHeight;
              const anim = content.animate(
                [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }],
                { duration: 300, easing: 'ease' }
              );
              anim.onfinish = () => { animating = false; };
            }
          });
        });
      }

      /* ---------- Kopieer e-mailtemplate ---------- */
      root.querySelectorAll('.tlrb-ref2__copy-btn').forEach(btn => {
        const labelEl = btn.querySelector('[data-copy-label]');

        btn.addEventListener('click', () => {
          const target = document.getElementById(btn.dataset.copyTarget);
          if (!target) return;
          const text = target.innerText;
          const done = btn.dataset.copyDone || 'Gekopieerd!';
          const def = btn.dataset.copyDefault || 'Kopieer';

          const onDone = () => {
            if (labelEl) labelEl.textContent = done;
            btn.classList.add('is-done');
            setTimeout(() => {
              if (labelEl) labelEl.textContent = def;
              btn.classList.remove('is-done');
            }, 2200);
          };

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(onDone).catch(() => fallbackCopy(text, onDone));
          } else {
            fallbackCopy(text, onDone);
          }
        });
      });

      function fallbackCopy(text, cb) {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        cb();
      }
    }

    function initAll() {
      document.querySelectorAll('.tlrb-ref2').forEach(function (root) {
        if (root.dataset.ref2Init === '1') return;
        root.dataset.ref2Init = '1';
        initRef2(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector ? e.target.querySelector('.tlrb-ref2') : null;
      if (root) root.dataset.ref2Init = '';
      initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlrb-referral"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRef(root) {
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // --- Scroll reveal (progressive enhancement) ---
      const items = root.querySelectorAll('[data-reveal]');

      if (items.length) {
        root.classList.add('js-reveal-ready');

        const revealAll = () => items.forEach(el => el.classList.add('is-revealed'));

        if (reduce || !('IntersectionObserver' in window)) {
          revealAll();
        } else {
          const io = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                obs.unobserve(entry.target);
              }
            });
          }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

          items.forEach(el => io.observe(el));

          // Vangnet: als items na 1.2s nog verborgen zijn (bijv. in de
          // theme editor), toon ze alsnog.
          setTimeout(() => {
            items.forEach(el => {
              if (!el.classList.contains('is-revealed')) {
                el.classList.add('is-revealed');
              }
            });
          }, 1200);
        }
      }

      // --- Count-up van het beloningsbedrag (€0 → €100) ---
      root.querySelectorAll('[data-countup]').forEach(el => {
        const original = el.textContent;
        const match = original.match(/\d[\d.,]*/);
        if (!match || reduce || !('IntersectionObserver' in window)) return;

        const numStr = match[0].replace(/[.,](?=\d{3}\b)/g, '');
        const target = parseInt(numStr, 10);
        if (!isFinite(target) || target <= 0 || target > 1000000) return;

        const prefix = original.slice(0, match.index);
        const suffix = original.slice(match.index + match[0].length);
        let started = false;

        const run = () => {
          if (started) return;
          started = true;
          const dur = 1100;
          const t0 = performance.now();
          const tick = (now) => {
            const p = Math.min((now - t0) / dur, 1);
            const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
            el.textContent = prefix + Math.round(eased * target) + suffix;
            if (p < 1) requestAnimationFrame(tick);
            else el.textContent = original;
          };
          requestAnimationFrame(tick);
        };

        const io = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              run();
              obs.disconnect();
            }
          });
        }, { threshold: 0.4 });
        io.observe(el);

        // Vangnet, net als bij de reveals.
        setTimeout(run, 1500);
      });

      // --- Soepel scrollen naar het formulier ---
      root.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', (e) => {
          const id = link.getAttribute('href').slice(1);
          const target = id && document.getElementById(id);
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      });

      // --- FAQ: vloeiend open/dicht ---
      if (!reduce && 'animate' in Element.prototype) {
        root.querySelectorAll('.tlrb-ref__faq-item').forEach(item => {
          const summary = item.querySelector('summary');
          const content = item.querySelector('.tlrb-ref__faq-a');
          if (!summary || !content) return;
          let animating = false;

          summary.addEventListener('click', (e) => {
            e.preventDefault();
            if (animating) return;
            animating = true;

            if (item.open) {
              const h = content.offsetHeight;
              const anim = content.animate(
                [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
                { duration: 240, easing: 'ease' }
              );
              anim.onfinish = () => {
                item.open = false;
                animating = false;
              };
            } else {
              item.open = true;
              const h = content.offsetHeight;
              const anim = content.animate(
                [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }],
                { duration: 300, easing: 'ease' }
              );
              anim.onfinish = () => { animating = false; };
            }
          });
        });
      }

      // --- Kopieer e-mailtemplate ---
      root.querySelectorAll('.tlrb-ref__copy-btn').forEach(btn => {
        const labelEl = btn.querySelector('[data-copy-label]');

        btn.addEventListener('click', () => {
          const target = document.getElementById(btn.dataset.copyTarget);
          if (!target) return;
          const text = target.innerText;
          const done = btn.dataset.copyDone || 'Gekopieerd!';
          const def = btn.dataset.copyDefault || 'Kopieer';

          const onDone = () => {
            if (labelEl) labelEl.textContent = done;
            else btn.textContent = done;
            btn.classList.add('is-done');
            setTimeout(() => {
              if (labelEl) labelEl.textContent = def;
              else btn.textContent = def;
              btn.classList.remove('is-done');
            }, 2200);
          };

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(onDone).catch(() => fallbackCopy(text, onDone));
          } else {
            fallbackCopy(text, onDone);
          }
        });
      });

      function fallbackCopy(text, cb) {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        cb();
      }
    }

    function initAll() {
      document.querySelectorAll('.tlrb-ref').forEach(function (root) {
        if (root.dataset.refInit === '1') return; // dubbele init voorkomen
        root.dataset.refInit = '1';
        initRef(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor: opnieuw initialiseren bij (her)laden van de sectie.
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector ? e.target.querySelector('.tlrb-ref') : null;
      if (root) {
        root.dataset.refInit = '';
      }
      initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlrb-scroll-overlay"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initOverlay(root) {
      var triggerPercent = parseInt(root.dataset.trigger, 10) || 50;
      var cookieDays = parseInt(root.dataset.cookieDays, 10) || 7;
      var cookieKey = root.dataset.cookieKey || 'tlrb_overlay';

      // If success message is showing, open immediately and skip trigger logic.
      var success = root.querySelector('.tlrb-overlay__success');
      if (success) {
        openOverlay();
        return;
      }

      // Skip if user already dismissed/submitted within cookie window.
      if (getCookie(cookieKey)) return;

      // Skip in the Shopify theme editor preview (avoid blocking the editor).
      if (window.Shopify && window.Shopify.designMode) return;

      var triggered = false;

      function checkScroll() {
        if (triggered) return;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (docHeight <= 0) return;
        var pct = (scrollTop / docHeight) * 100;
        if (pct >= triggerPercent) {
          triggered = true;
          openOverlay();
          window.removeEventListener('scroll', onScroll);
        }
      }

      function onScroll() {
        // Throttle via requestAnimationFrame.
        if (onScroll._raf) return;
        onScroll._raf = requestAnimationFrame(function () {
          onScroll._raf = null;
          checkScroll();
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });

      function openOverlay() {
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        // Force reflow before adding is-visible so transition runs.
        void root.offsetWidth;
        root.classList.add('is-visible');
        document.body.style.overflow = 'hidden';

        // Focus the first input for accessibility.
        var firstInput = root.querySelector('input');
        if (firstInput) {
          setTimeout(function () { firstInput.focus(); }, 300);
        }
      }

      function closeOverlay() {
        root.classList.remove('is-visible');
        document.body.style.overflow = '';
        setTimeout(function () {
          root.classList.remove('is-open');
          root.setAttribute('aria-hidden', 'true');
        }, 400);
        setCookie(cookieKey, '1', cookieDays);
      }

      // Close button(s)
      root.querySelectorAll('[data-overlay-close]').forEach(function (btn) {
        btn.addEventListener('click', closeOverlay);
      });

      // Click on backdrop to close
      var backdrop = root.querySelector('.tlrb-overlay__backdrop');
      if (backdrop) {
        backdrop.addEventListener('click', closeOverlay);
      }

      // Esc key to close
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('is-visible')) {
          closeOverlay();
        }
      });

      function setCookie(name, value, days) {
        var expires = '';
        if (days) {
          var d = new Date();
          d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
          expires = '; expires=' + d.toUTCString();
        }
        document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
      }
      function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
        return match ? match[2] : null;
      }
    }

    function initAll() {
      document.querySelectorAll('.tlrb-overlay').forEach(function (root) {
        if (root.dataset.overlayInit === '1') return;
        root.dataset.overlayInit = '1';
        initOverlay(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector ? e.target.querySelector('.tlrb-overlay') : null;
      if (root) root.dataset.overlayInit = '';
      initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlrd-video-hero-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript && document.currentScript.closest ? null : null;
    var els = document.querySelectorAll('.tlrd-vh [data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.14 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
